import { datetimeFormats } from './datetime-formats'

export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: 'en',
  datetimeFormats
}))
